<template>
  <div>
    <v-layout row wrap>
          <v-btn icon @click="openBox()" right absolute>
          <v-icon>unfold_more</v-icon>
          </v-btn>
          <h1 class="text-info font-size-18">
            Regularidade<strong> Fiscal e Trabalhista</strong>
          </h1>
    </v-layout>
    <v-layout row wrap v-show="showBox">
      <v-flex sm12>
        <v-card id="teste003">
            <v-data-table
              :headers="headers"
              :items="model.regularidadeFiscTrab"
              :hide-actions="true"
            >
            
            <template slot="items" slot-scope="props">
              <tr>
              <td width="30%"><strong>{{retornaEnumDescricao("tipoDocumento",props.item.tipDocumento)}}</strong></td>
              <td width="20%" >{{props.item.numDocumento}}</td>
              <td width="10%"
                :class="{ 'texto-positiva-vermelha': deveSerVermelho(props.item) }">
              {{ retornaEnumDescricao("situacaoDoc", props.item.situacaoDoc) }}
            </td>

              <td width="10%" >{{props.item.dtEmissao | dataFormatada}}</td>
              <td v-bind:class="{'dataVencida':verificaDataVencida(props.item.dtVencimento)}">{{props.item.dtVencimento | dataFormatada}}</td>
              <td >{{props.item.codControle}}</td>
              <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" width="5%">              
               <a 
                  v-show="props.item.arquivoUpload && props.item.arquivoUpload !== 'Não Encontrado'"
                >

                <v-icon 
                :color="(
                props.item.regularidadeFiscTrabSituacao === 2
                    ? 'blue'
                    : (props.item.regularidadeFiscTrabSituacao === 1)
                      ? 'red'
                      : 'grey'
                )"
                :disabled="!(
                  String(props.item.arquivoUpload).includes('https') || 
                  (props.item.regularidadeFiscTrabSituacao === 1 && String(props.item.arquivoUpload).includes('.pdf'))
                )"
                @click.native="handleIconClick(props.item.arquivoUpload, props.item.regularidadeFiscTrabSituacao)"
              >
                attach_file
              </v-icon>
                </a>
     
              </td> 
            </tr>
            <!-- Nova linha solicitada no ticket 161107 -->
            <tr v-if="model.regularidadeFiscTrab[model.regularidadeFiscTrab.length-1].$id == props.item.$id">
              <td  width="30%"><strong>DATA DE ABERTURA DA EMPRESA</strong></td>
              <td width="20%" >{{ dataAberturaEmpresaFormatada }}</td>
              <td width="10%"></td>
              <td width="10%"></td>
              <td></td>
              <td></td>
              <td width="5%"></td>
            </tr>
            <!-- / Nova linha solicitada no ticket 161107 -->

          </template>
        </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>
<script>

import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "extrato-regularidade-fiscal",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio:Object,
    enums:Object,
  },
  created() /*Metodo de start do componente*/{
    // let perfil = this.$store.getters.getPerfil;
    this.getRegularidadeFiscalTipoDoc();
    
    // this.model.regularidadeFiscTrab.forEach((item)=>{
    //   if(item.tipDocumento === 999){
        
    //     switch (this.$store.getters.getPerfil) {
    //       case "administrador":
    //             break;
    //           case "cadastrador":
    //             break;
    //           case "validador":
    //             break;
    //           case "validadormaster":
    //             break;
    //           default:
    //           regularidadeFiscTrabFiltro = this.model.regularidadeFiscTrab.filter((e)=>e.tipDocumento !== 999 )
    //              break;
    //       }
    //   }

    // })

    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {

      this.headers.push({
        text: this.$t("label.anexo"),       
        sortable: false,        
      });    
    }

  },
  data() {//Declaracao de variaveis

    return {
      regularidadeTipoDoc: {},
      showBox:true,
      headers:[ {
          text: "",
          sortable: false,
        },

        {
          text: this.$t('label.numeroDocumento'),
          sortable: false,
        },

        {
          text: this.$t('label.situacao'),
          sortable: false,

        },
        {
          text: "Dt. Emissão",
          sortable: false,
        },

        {
          text: "Dt. Validade",
          sortable: false,
        },

        {
          text: this.$t('label.codDeControle'),
          sortable: false,
        },

       
      ]
    };

  },
  computed: {
  dataAberturaEmpresaFormatada() {
    // Verificação segura sem operador ?.
    const dtAbertura = this.regularidadeTipoDoc && this.regularidadeTipoDoc.dtAberturaEmpresa;

    const data = dtAbertura
      ? new Date(dtAbertura)
      : new Date();

    // Valida se a data é válida (caso dtAbertura seja string vazia ou inválida)
    if (isNaN(data.getTime())) {
      return new Date().toLocaleDateString('pt-BR'); // fallback adicional
    }

    const day = String(data.getDate()).padStart(2, '0');
    const month = String(data.getMonth() + 1).padStart(2, '0');
    const year = data.getFullYear();
    return `${day}/${month}/${year}`;
  }
},
  methods: {//Declaracao de todos os metodos

    openBox(){

      this.showBox=!this.showBox;
    },
     handleIconClick(arquivo,situacao) {
    if (arquivo.includes('https')) {
      window.open(arquivo, '_blank');
    } else if (situacao === 1 && arquivo.includes('.pdf')) {
      this.baixarArquivo(arquivo);
    }
  },
      retornaTipoQualificacao(tipoQualificacao){
        //retorna o tipo de qualificacao
      if (!tipoQualificacao || !this.enums.tipoQualificacao) return ''
      let tpQualificacao = this.enums.tipoQualificacao.find(x=>x.valor===tipoQualificacao);
      return tpQualificacao ? tpQualificacao.descricao : null;
    },
      deveSerVermelho(item) {
      const tiposPermitidos = [5, 6, 4];
      const descricaoSituacao = this.retornaEnumDescricao("situacaoDoc", item.situacaoDoc);
      return tiposPermitidos.includes(item.tipDocumento) && descricaoSituacao === "Positiva";
    },
    getRegularidadeFiscalTipoDoc() {

      fornecedorService.getRegularidadeFiscalTipoDoc(this.model.numCgcFornecedor, 1).then(response => { /*resposta do servico*/
      
        this.regularidadeTipoDoc = response.data; /*dados de retorno*/
        // this.regularidadeTipoDoc.numDocumento = this.regularidadeTipoDoc.dtAberturaEmpresa | dataFormatada;
        //this.model.regularidadeFiscTrab.push(this.regularidadeTipoDoc);
      }).catch(() => {
      });
    },

  baixarArquivo(arquivo) {
        //baixar o documento
       
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },
    retornaEnumDescricao(_enum,valor){
      //retorna a descricao do enum
      if (!valor || !this.enums[_enum]) return '';
      let retorno = this.enums[_enum].find(x=>x.valor===valor);
      return retorno ? retorno.descricao : null;
    },

     /**
   * Retorna classe CSS para destacar situação "Positiva" em vermelho
   * nos documentos de regularidade fiscal específicos
   */
    getClasseSituacaoPositiva(tipDocumento, situacaoDoc) {
      // Verificar pelo nome real do documento
      var nomeDocumento = this.retornaEnumDescricao("tipoDocumento", tipDocumento);
      var situacaoTexto = this.retornaEnumDescricao("situacaoDoc", situacaoDoc);
      
      if (!nomeDocumento || !situacaoTexto) {
        return '';
      }
      
      // Documentos específicos pelos nomes exatos
      var documentosEspecificos = [
        'REGULARIDADE FAZENDA FEDERAL E A DIVIDA ATIVA E INSS',
        'REGULARIDADE COM A FAZENDA ESTADUAL',
        'REGULARIDADE COM A FAZENDA MUNICIPAL'
      ];
      
      // Verificar se é um dos documentos específicos
      var ehDocumentoEspecifico = false;
      for (var i = 0; i < documentosEspecificos.length; i++) {
        if (nomeDocumento.indexOf(documentosEspecificos[i]) !== -1) {
          ehDocumentoEspecifico = true;
          break;
        }
      }
      
      // Aplicar vermelho APENAS se for documento específico + situação positiva
      return (ehDocumentoEspecifico && situacaoTexto === 'Positiva') ? 'status-positivo-vermelho' : '';
    }
  },
};
</script>

<style scoped> /*CSS especifico do componente*/
  .infoDados .v-card{ padding: 15px;}

  .infoDados .linhaInfo{
  display: block;
  padding: 5px 0;
  }

  .theme--light.v-table thead{
    background: none;
  }
  #teste003{
    float: left;
    padding: 5px;
  }

  /* Classe para destacar situação "Positiva" em vermelho */
  .status-positivo-vermelho {
    color: #d32f2f !important;
    font-weight: bold !important;
  }
  .texto-positiva-vermelha {
  color: red !important; /* ou use uma variável de cor, ex: var(--danger) */
}
</style>


